import { InjectionToken } from '@angular/core';

/**
 * @const EXCLUDED_URLS
 * don't apply the interceptor to these urls
 * you can use this token to inject specific urls from each application
 */
export const EXCLUDED_URLS_FOR_INTERCEPTOR: InjectionToken<string[]> = new InjectionToken('EXCLUDED_URLS_FOR_INTERCEPTOR');
